import { cn } from '@/components/ui/cn';

/**
 * A single shimmering placeholder block. Decorative only (aria-hidden); the
 * surrounding loading state is announced to assistive tech separately. The
 * pulse animation is disabled under prefers-reduced-motion.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded bg-gray-200 motion-reduce:animate-none', className)}
    />
  );
}

/** A stack of full-width skeleton bars, sized to stand in for table/list rows. */
export function SkeletonRows({ rows = 4, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('space-y-3', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-5 w-full" />
      ))}
    </div>
  );
}
